import React from 'react';

interface TenantIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  color?: string;
}

const TenantIcon: React.FC<TenantIconProps> = ({
  width = 24,
  height = 24,
  className = '',
  color = '#fff',
}) => {
  return (
    <svg
      data-icon="search-around"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M13.5 11c-.51 0-.98.15-1.38.42l-2.4-2.41c.17-.3.28-.64.28-1.01s-.11-.71-.28-1.01l2.41-2.41c.39.27.86.42 1.37.42a2.5 2.5 0 000-5A2.5 2.5 0 0011 2.5c0 .51.15.98.42 1.38l-2.41 2.4C8.71 6.11 8.37 6 8 6s-.71.11-1.01.28l-2.41-2.4c.27-.4.42-.87.42-1.38a2.5 2.5 0 00-5 0A2.5 2.5 0 002.5 5c.51 0 .98-.15 1.38-.42l2.41 2.41C6.11 7.29 6 7.63 6 8s.11.71.28 1.01l-2.41 2.41c-.39-.27-.86-.42-1.37-.42a2.5 2.5 0 000 5A2.5 2.5 0 005 13.5c0-.51-.15-.98-.42-1.38l2.41-2.41c.3.18.64.29 1.01.29s.71-.11 1.01-.28l2.41 2.41c-.27.39-.42.86-.42 1.37a2.5 2.5 0 005 0 2.5 2.5 0 00-2.5-2.5zm0-10c.83 0 1.5.67 1.5 1.5S14.33 4 13.5 4 12 3.33 12 2.5 12.67 1 13.5 1zm-11 3C1.67 4 1 3.33 1 2.5S1.67 1 2.5 1 4 1.67 4 2.5 3.33 4 2.5 4zm0 11c-.83 0-1.5-.67-1.5-1.5S1.67 12 2.5 12s1.5.67 1.5 1.5S3.33 15 2.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
        fillRule="evenodd"
        fill={color}
      />
    </svg>
  );
};

/**
 * The tenant icon as a navbar icon: it follows the text colour of the button it is in,
 * so it stays visible on both the light sub-menu bar and an active (blue) button.
 */
export function IconTenant(): JSX.Element {
  return (
    <span className="bp3-icon">
      <TenantIcon width={16} height={16} color="currentColor" />
    </span>
  );
}

export default TenantIcon;
